
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-demo",
      function () {
        return require("private-next-pages/product-demo.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product-demo"])
      });
    }
  